<template>
  <div class="plans-container" v-if="!!products">

    <!-- Trial -->
    <div v-if="user_type=='trial'">
      <div>
        <div class="header-title">
          <div>BiblioTrees로</div>
          <div>편리한 연구를 시작하세요</div>
        </div>
        <div class="header-meta">
          <div>아래에서 원하시는 메뉴를 선택해주세요</div>
        </div>
      </div>

      <router-link tag="div" class="pointer-element"
        :to="{name: 'lab'}">
        <v-card flat class="plan plan-selected">
          <div class="plan-title">바로 <span class="explanation">내 랩</span> 으로 이동하기</div>
          <div>{{ end_date }}까지 프리미엄 이용권을 무료로 사용할 수 있습니다.</div>
        </v-card>
      </router-link>

      <div class="divider">
        <v-divider></v-divider>
        <span>or</span>
        <v-divider></v-divider>
      </div>

    </div>

    <div v-else>
      <div class="header-title">
        <div>BiblioTrees 프리미엄 구독</div>
      </div>
      <!-- <div class="header-subtitle">
        <div>이벤트가 종료되는 {{ end_date }} 이후 결제가 시작됩니다.</div>
      </div> -->
      <div class="header-meta">
        <div>아래 이용권을 선택해주세요.</div>
      </div>
    </div>

    <!-- 2021 event -->
    <div v-if="user_type == 'basic'">
      <div v-for="prod in event_products" :key="prod.prod_id"
        tag="div" class="pointer-element" @click="event_prod=prod.prod_id;event_dialog=true">
        <v-card flat class="plan plan-selected">
          <div class="plan-title">{{ $t('plans.'+prod.name) }}</div>
          <div>오늘부터 한 달간, <span class="explanation">프리미엄 이용권을 무료로</span> 사용하세요!</div>
        </v-card>
      </div>
    </div>

    <div class="plans" v-for="prod in products" :key="prod.prod_id">
      <v-card flat class="plan plan-selected" @click="next(prod.prod_id)">
        <div class="plan-title-wrapper">
          <!-- <div v-if="user_type=='trial'" class="plan-title">얼리버드 특가로 <span class="explanation">이용권 구독</span> 신청하기</div> -->
          <div class="plan-title">프리미엄 이용권</div>
        </div>
        <div class="plan-price-wrapper">
          <div class="plan-price-col">
            <v-icon small class="plan-icon plan-icon-selected">
              mdi-check-circle
            </v-icon>
            <span class="real-price">{{ $t('plans.'+prod.name) }}</span>
          </div>
          <div class="plan-price-col">
            <div class="original-price" v-if="prod.kind==4">
              <del>
                {{ $t('plans.price_'+price_unit,
                  [parseInt(prod['original_price_'+price_unit]).toLocaleString()])}}
              </del>
            </div>
            <div class="real-price">
              {{ $t('plans.price_'+price_unit,
                [parseInt(prod['price_'+price_unit]).toLocaleString()]) }}
            </div>
          </div>
        </div>
      </v-card>
    </div>

    <div class="premium-wrap">
      <div class="premium-title">프리미엄 회원 특전</div>
      <div>
        <div class="premium-func">
          <div><v-icon color="primary">mdi-check</v-icon></div>
          <div>프로젝트 무제한 생성</div>
        </div>
        <div class="premium-func">
          <div><v-icon color="primary">mdi-check</v-icon></div>
          <div>다른 회원에게 프로젝트 공유(예정)</div>
        </div>
        <div class="premium-func">
          <div><v-icon color="primary">mdi-check</v-icon></div>
          <div>관심 도큐먼트를 한 곳에 저장</div>
        </div>
        <div class="premium-func">
          <div><v-icon color="primary">mdi-check</v-icon></div>
          <div>내가 쓴 리뷰 모아보기</div>
        </div>
      </div>
    </div>

    <!-- Event dialog -->
    <template>
      <v-dialog v-model="event_dialog" width="400px">
        <v-card>
          <v-card-title>
            이벤트를 신청하시겠습니까?
          </v-card-title>
          <v-card-text>
            아래 신청 버튼을 클릭하시면 오늘부터 한 달간 프리미엄 이용권 무료 사용이 시작됩니다.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="event_dialog=false">
              {{ $t('actions.close') }}
            </v-btn>
            <v-btn small depressed color="primary"
              @click="startEvent()">
              신청하기
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
      products: [],
      event_products: [],
      user_type: null,
      end_date: null,
      price_unit: 'KRW',
      event_dialog: false,
      event_prod: null,
    }
  },

  async created() {
    let error = false
    try {
      await this.$store.dispatch('welcome/getProducts')
      await this.$store.dispatch('user/getUserInfo')
    } 
    catch(e) {
      error = true
      let status = !!e.response ? e.response.status : '000'
      this.$store.commit('error/setErrorCode', e.response.status)
      this.$store.commit('error/setDialog', true)
    } 
    finally {
      if (!error) {
        this.user_type = this.$store.getters['user/user_type']
        this.end_date = this.$store.getters['user/end_date']
        this.products = this.$store.getters['welcome/products']
          .filter(v => v.kind == 4)
          .sort((a, b) => a['price_KRW'] - b['price_KRW'])
        this.event_products = this.$store.getters['welcome/products']
          .filter(v => v.kind == 2)
          .sort((a, b) => a['price_KRW'] - b['price_KRW'])
      }
    }
  },

  methods: {
    next(prod_id) {
      this.$store.commit('welcome/setProdId', prod_id)
      this.$router.push({name:'signupform', params: {code: 'payment'}})
      this.$analytics.logEvent('click', { name: 'plans_btn_next' })
    },

    initiate() {
      this.$store.commit('welcome/setProdId', null)
    },

    async startEvent() {
      // console.log('prod_id', this.event_prod)
      try {
        await this.$store.dispatch('payment/startTrial', {
          product: this.event_prod
        })
      } finally {
        let payment = this.$store.getters['payment/payment']
        this.$analytics.logEvent('purchase', { 
          transactions_id: payment.pay_id,
          value: payment.amount,
          currency: payment.unit,
          product: payment.product,
          name: payment.product_name,
          kind: payment.kind,
          status: payment.status,
        })
        this.$analytics.logEvent('event_2021')
        this.$router.push({name:'lab'})
      }
    }
  },
}
</script>

<style scoped>

  .header-title {
    padding: 10px 0 20px;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-subtitle {
    padding: 10px 0 20px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #E0457A;
  }

  .header-meta {
    font-size: 14px;
    text-align: center;
    margin-bottom: 24px;
  }

  .divider {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0;
    color: #B3A8B5;
  }

  .explanation {
    color: #E0457A;
  }

  .plan {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    /* background-color: rgba(237, 237, 237, 0.4) !important; */
    margin-bottom: 20px;
    min-height: 95px;
  }

  .plan-selected {
    border: #E0457A 2px solid !important;
  }

  .plan-title-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .plan-icon {
    color: #B3A8B5 !important;
    font-size: 20px;
    margin-right: 5px;
  }

  .plan-icon-selected {
    color: #E0457A !important;
  }

  .plan-price-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

  .plan-price-col {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .plan-title {
    font-size: 18px;
    font-weight: 700;
  }

  .real-price {
    font-size: 16px;
    font-weight: 700;
  }

  .plan-price, .plan-meta {
    display: flex;
    flex-direction: row;
    align-items: baseline;
  }

  .plan-meta {
    font-size: 14px;
  }

  .original-price {
    font-size: 14px;
    color: #B3A8B5;
    margin-right: 3px;
  }

  .footnote {
    margin-bottom: 16px;
  }

  .action {
    margin-top: 32px !important;
  }

  .premium-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .premium-title {
    font-size: 18px;
    font-weight: 700;
    margin: 12px 0;
  }

  .premium-func {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
  }

  .premium-func i {
    margin-right: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared_components/form/Plans.vue